import { API_URL } from "../constants";
import axios from "axios";
import middleware from "../util/middleware";
import { getSegmento } from "../util/generics";

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        'x-segmento': getSegmento()
    }
});

class ArticulosCiclicosRequest {

    static obtenerNoConfigurados(filtro) {
        return middleware.hasAuth(() => request.get('/barras/ciclicos/config/nolist', {
            params: {
                busqueda: filtro
            }
        }))
    }

    static guardarCiclicos(data) {
        return middleware.hasAuth(() => request.post('/barras/ciclicos/config', data))
    }

    static obtenerArticulosCiclicos(filtros) {
        return middleware.hasAuth(() => request.get('/barras/ciclicos/config', {
            params: {
                frecuencia: filtros?.frecuencia,
                busqueda: filtros?.filtro ?? undefined
            }
        }))
    }

    static actualizarFrecuenciaArticulo(data) {
        return middleware.hasAuth(() => request.put('/barras/ciclicos/config', data))
    }

    static eliminarArticuloCiclico(data) {
        return middleware.hasAuth(() => request.delete('/barras/ciclicos/config', { data }));
    }

}

export default ArticulosCiclicosRequest